import { Badge } from 'src/components/ui/Badge';
import { Disclosure } from 'src/components/ui/Disclosure';
import { COMMAND_LABEL, COMMAND_STATUS_LABEL, COMMAND_STATUS_TONE } from 'src/lib/speakerProfiles';
import { formatDateTime } from 'src/lib/time';
import type { EditorialSpeakerCommand } from 'src/types/editorial';

/**
 * What has been asked for and not yet applied.
 *
 * The pipeline box owns the training audio, so an edit made here waits until its next run — which
 * can be the next morning's broadcast. Without this list a rename simply appears not to have
 * worked, and the editor does it again.
 */
export function PendingCommands({ commands }: { commands: EditorialSpeakerCommand[] }) {
  const pending = commands.filter(command => command.status === 'pending' || command.status === 'running');
  const failed = commands.filter(command => command.status === 'failed');

  if (pending.length === 0 && failed.length === 0) return null;

  return (
    <section className="commands">
      {pending.length > 0 && (
        <p className="commands__note">
          {pending.length} {pending.length === 1 ? 'cambio pendiente' : 'cambios pendientes'}. Se aplican cuando el
          pipeline procese el siguiente stream.
        </p>
      )}
      {failed.length > 0 && (
        <p className="commands__note commands__note--failed">
          {failed.length} {failed.length === 1 ? 'cambio falló' : 'cambios fallaron'} al aplicarse. Abre el detalle para
          ver el motivo.
        </p>
      )}

      <Disclosure summary="Cambios en cola" count={pending.length + failed.length}>
        <ul className="commands__list">
          {[...pending, ...failed].map(command => (
            <li key={command.commandId}>
              <span className="commands__type">{COMMAND_LABEL[command.type]}</span>
              <Badge tone={COMMAND_STATUS_TONE[command.status] ?? 'unresolved'}>
                {COMMAND_STATUS_LABEL[command.status] ?? command.status}
              </Badge>
              <span className="commands__when">{formatDateTime(command.requestedAt)}</span>
              {command.error && <span className="commands__error">{command.error}</span>}
            </li>
          ))}
        </ul>
      </Disclosure>
    </section>
  );
}
